import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Response, RequestOptions, Request, Headers } from '@angular/http';
import { Observable } from 'rxjs/';
import { Facility } from 'models/facility.model';
import { CompletedSurvey } from 'models/completed-survey.model';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  readonly rootUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) { }

  getSurvey(IDElaborazioneCompilativa): Observable<any> {
    IDElaborazioneCompilativa = IDElaborazioneCompilativa
    let currentPage = 1
    let Offset = 10
    var data = '?IDElaborazioneCompilativa=' + IDElaborazioneCompilativa + '&CurrentPage=' + currentPage + '&Offset=' + Offset;
    return this.http.get(this.rootUrl + '/api/Survey/get' + data);
  }

  surveyUpsert(completedSurvey: CompletedSurvey): Observable<any> {
    return this.http.post(this.rootUrl + '/api/Survey/save', completedSurvey);
  }

  surveyRead(IDElaborazioneCompilativa): Observable<any> {
    IDElaborazioneCompilativa = IDElaborazioneCompilativa
    let currentPage = 1
    let Offset = 10
    var data = '?IDElaborazioneCompilativa=' + IDElaborazioneCompilativa + '&CurrentPage=' + currentPage + '&Offset=' + Offset;
    return this.http.get(this.rootUrl + '/api/Survey/read' + data);
  }
}
